import request from "@/utils/request";

export function completeUploadFinalDraft(designId,orderId) {
    return request({
        url: `/design/completeUploadFinalDraft`,
        method: 'get',
        params: {
            orderId: orderId,
            designId:designId,
        }
    })
}

export function skipDesign(orderId) {
    return request({
        url: `/design/skipDesign`,
        method: 'put',
        params:{
            orderId: orderId,},
    })
}

export function getDesignPage(data,pageNum,pageSize) {
    return request({
        url: `/order/findManagePage`,
        method: 'post',
        params:{pageNum,pageSize},
        data
    })
}
